import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import axios from 'axios';
import qs from 'query-string';
import lodash from 'lodash';

import { apiLoginAuth, apiConfig } from '@/services/api-config';
import showError from '@/handler/error';
import {
  GetQuestionParams,
  NotificationEntity,
  NotificationParams,
  PaymentMethod,
  QuestionType,
  RouterProps,
} from '@/config/types';
import switchNotificationType from '@/utils/switch-status-notification';
import { getQuestionByEvidenceId } from '@/services/territory/get-question-by-evidence-id';
import { getAppointment } from '@/services/territory/get-appointment';
import { objectiveQUestion } from '@/utils/objective-question';
import { subjectivQuestion } from '@/utils/subjectiv-question';
import { formatAppointmentText } from '@/utils/format-appointment-text';
import { getAppointmentByCdAgent } from '@/services/appoinments/get-appointment-by-territory-ids';
import { getAgent } from '@/services/user/get-agent';

const locale = window.navigator.language;

moment.locale(locale);

Vue.use(Vuex);

function initialState() {
  return {
    userLogged: null,
    notificationData: {},
    notificationsUnread: [] as any[],
    notificationsRead: [] as any[],
    isFrig: false,
    routes: [] as RouterProps[],
    question: {} as any,
    statusGet: {},
    dataAppointment: [] as any[],
    appointments: [] as any[],
    territoryArray: [] as any[],
    appointmentsNotification: [] as any[],
    DateById: {},
    Link: {},
    stepsRegisterTerritoryData: {
      conditionSkip: false,
      currentStep: 1,
      address: {
        address: '',
        zipCode: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
        complement: '',
      },
      territory: {
        id: '',
        car: '',
        name: '',
        geometry: '',
        codCounty: '',
        representative: {
          name: '',
          document: '',
          office: '',
        },
      },
      agent: {
        id: '',
      },
      img: {
        url: '',
        retry: false,
        isImgHidden: true,
      },
      report: { urlExtract: '' },
      term: { termId: 0, urlFile: '' },
      penalty: { penaltyValue: 0, totalInstallments: 0, installments: 0 },
      tickets: [],
      isErrors: false,
      isLoadingPayment: true,
      refs: { car: {} as any },
      gixUrl: '',
      paymentMethod: PaymentMethod.INSTALLMENTS,
    },
    DateAct: {},
    DateFrigo: {} as any,
    DataNotification: {},
    cdAgent: '',
    ticket: {} as any,
    act: {} as any,
    genericReadData: {} as any,
    DataPix: {},
    ignoreSteep: false,
    hasAvaliableVoucher: false,
    termsAccept: false,
  };
}

export default new Vuex.Store({
  state: initialState(),
  mutations: {
    resetState(state) {
      Object.assign(state, initialState());
    },
    setUserLogged(state, user) {
      state.userLogged = user;
    },
    setDataGetNotification(state, notificationData) {
      state.notificationData = notificationData;
    },
    setNotificationUnread(state, data) {
      state.notificationsUnread = data;
    },
    setNotificationRead(state, data) {
      state.notificationsRead = data;
    },
    setRoutes(state, data) {
      state.routes = data;
    },
    setQuestion(state, data) {
      state.question = data;
    },
    setStatus(state, statusGet) {
      state.statusGet = statusGet;
    },
    setAppointmemt(state, data) {
      state.appointments = data;
    },
    setAppointmentsNotification(state, data) {
      state.appointmentsNotification = data;
    },
    setDateAappointments(state, DateById) {
      state.DateById = DateById;
    },
    setNotificationDate(state, DateById) {
      state.DateById = DateById;
    },
    setNotificationAppoint(state, DataNotification) {
      state.DataNotification = DataNotification;
    },
    setLink(state, Link) {
      state.Link = Link;
    },
    resetStepsRegisterTerritory(state) {
      state.stepsRegisterTerritoryData = initialState().stepsRegisterTerritoryData;
    },
    setStepRegister(state, data) {
      state.stepsRegisterTerritoryData = data;
    },
    setDateAct(state, DateAct) {
      state.DateAct = DateAct;
    },
    setTickets(state, ticket) {
      state.ticket = ticket;
    },
    setAct(state, act) {
      state.act = act;
    },
    setReadGeneric(state, genericReadData) {
      state.genericReadData = genericReadData;
    },
    setDatePix(state, DataPix) {
      state.DataPix = DataPix;
    },
    setAppointmentsNotificationAppoint(state, data) {
      state.appointments = data;
    },
    setVoucherUsability(state, value: boolean) {
      state.hasAvaliableVoucher = value;
    },
    setTermsAccept(state, value: boolean) {
      state.termsAccept = value;
    },
  },
  actions: {
    resetState({ commit }) {
      commit('resetState');
    },
    async login({ commit }, params) {
      return apiLoginAuth
        .get('', {
          params,
        })
        .then((response) => {
          const { hasErrors, objectResult } = response.data;
          const result = !hasErrors && objectResult;
          if (result && objectResult.company.alias.includes(process.env.VUE_APP_CLIENT)) {
            commit('setUserLogged', objectResult);
            sessionStorage.setItem('userLogged', JSON.stringify(objectResult));
          } else throw new Error('Nenhuma aplicação encontrada.');

          return result;
        })
        .catch((error) => ({
          hasErrors: true,
          message: error.response.data.message,
        }));
    },
    async getTickets({ commit }, params: any) {
      const uri = 'api/Ticket/get-tickets-by-cdterritory';
      return apiConfig
        .post(uri, params, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          commit('setTickets', response);
        });
    },
    async getAppointmentData({ commit }, params: any) {
      const uri = `api/appointments/get-by-id-agent-id-territory?agentId=${params.agentId}&territoryId=${params.cdTerritory}&tokenKey=${params.tokenKey}`;
      return apiConfig
        .get(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          commit('setAppointmemt', response);
        });
    },
    async getPix({ commit }, txid) {
      const uri = `api/Payment/get-pix?txid=${txid}`;
      return apiConfig
        .get(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          commit('setDatePix', response);
        });
    },
    async generatePix(context, object: any) {
      const uri = `api/Payment/createPix?txid=${object.txId}`;
      return apiConfig
        .post(`${uri}`, object, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          Vue.swal('', 'Pix gerado', 'success');
        });
    },
    async getLinkGix({ commit }, cdTerritory) {
      const uri = `api/Gix/create-link?tokenKey=${'nF3K9Vry9z3nNDwSYxxRKw=='}&cdTerritory=${cdTerritory}`;
      return apiConfig
        .get(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          commit('setLink', response);
        });
    },
    async getDateAct({ commit }, cdTerritory) {
      const uri = `api/ActDocument/get-by-cdTerritory?tokenKey=${'nF3K9Vry9z3nNDwSYxxRKw=='}&cdTerritory=${cdTerritory}`;
      return apiConfig
        .get(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          commit('setDateAct', response);
        });
    },
    async genericRead({ commit }, { idUser, isRead, tokenKey }) {
      const uri = `api/GenericRead/create-read?idUser=${idUser}&isRead=${isRead}&tokenKey=${tokenKey}`;
      return apiConfig
        .post(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          commit('');
        });
    },
    async genericReadGetbyidUser({ commit }, { idUser }) {
      const uri = `api/GenericRead/get-id-user?idUser=${idUser}`;
      return apiConfig
        .post(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          commit('setReadGeneric', response);
        });
    },
    async getNotificationData({ commit }, userId) {
      const uri = `api/territoryaccess/get-unread?userType=Produtor&userId=${userId}&tokenKey=${'nF3K9Vry9z3nNDwSYxxRKw=='}`;
      return apiConfig
        .get(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          commit('setDataGetNotification', response);
        });
    },
    async getAct({ commit }, { tokenKey, cdTerritory }) {
      return apiConfig
        .get(`api/ActDocument/get-by-cdTerritory?cdTerritory=${cdTerritory}&tokenKey=${tokenKey}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          commit('setAct', response);
        });
    },
    async getNotificationAppoint({ commit }, params) {
      const query = qs.stringify(params);
      const uri = `api/Appointments/get-by-user?${query}`;
      return apiConfig
        .get(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(({ data }) => {
          commit('setNotificationAppoint', data.objectResult);
        });
    },
    async getStatusbycdUser({ commit }, params) {
      const query = qs.stringify(params);
      const uri = `api/TermStatus/get-by-cdUser?${query}`;
      return apiConfig
        .get(uri, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(({ data }) => {
          if (data.objectResult && data.objectResult.status != null && data.objectResult.status === 'Aceite') {
            this.state.termsAccept = true;
          }
          commit('setStatus', data.objectResult);
        });
    },
    async getNotificationUnread({ commit }, params: NotificationParams) {
      const query = {
        userType: params.type,
        userId: params.userId,
        tokenKey: params.tokenKey,
      };
      const queryParse = qs.stringify(query);

      const url = `api/territoryaccess/get-unread?${queryParse}`;

      axios
        .all([apiConfig.get(url)])
        .then(
          axios.spread((data1) => {
            commit('setNotificationUnread', [...data1.data.objectResult]);
          }),
        )
        .catch(showError);
    },
    async getNotificationRead({ commit }, params: NotificationParams) {
      const query = {
        userType: params.type,
        userId: params.userId,
        tokenKey: params.tokenKey,
      };
      const queryParse = qs.stringify(query);

      const url = `api/territoryaccess/get-read?${queryParse}`;

      axios
        .all([apiConfig.get(url)])
        .then(
          axios.spread((data1) => {
            commit('setNotificationRead', [...data1.data.objectResult]);
          }),
        )
        .catch(showError);
    },
    async insertDateStatus(context, params) {
      const uri = 'api/TermStatus/create';
      return apiConfig
        .post(`${uri}`, params, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((json) => {
          if (json && json.data && json.data.hasErrors === true) {
            throw new Error('Erro ao salvar o aceite do termo');
          }
          Vue.swal('', 'Seja bem vindo ao PREM', 'success');
        });
    },
    async postTickts({ commit }, {
      cdTerritory, isRead, ticketName, tokenKey,
    }) {
      return apiConfig
        .post(
          `/api/Ticket/create-read?cdTerritory=${cdTerritory}&isRead=${isRead}&tokenKey=${tokenKey}&ticketName=${ticketName}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then(() => {
          commit('');
        })
        .catch((error) => error.type);
    },
    async gerarAct(context, params) {
      const uri = 'api/ActDocument/create';
      return apiConfig
        .post(`${uri}`, params, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          console.log('datas geradas');
        });
    },
    async getAppointmentNotification({ commit }, { territoryId }) {
      const uri = `api/Appointments/get-by-id-notification?territoryId=${territoryId}&tokenKey=nF3K9Vry9z3nNDwSYxxRKw==`;
      return apiConfig.get(uri, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        commit('setNotificationAppoint', response);
      });
    },
    async removeMonitory({ commit }, { frigId, territoryId, TokenKey }) {
      return apiConfig
        .post(
          `api/TerritoryAccess/delete?frigId=${frigId}&territoryId=${territoryId}&TokenKey=${TokenKey}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          const { data } = response;
          Vue.swal('', data.message, 'success');
          commit('');
        })
        .catch((error) => error.type);
    },
    async getAppointmentDate({ commit }, { agentId, territoryId }) {
      const uri = `api/appointments/get-by-id-agent-id-territory?agentId=${agentId}&territoryId=${territoryId}&tokenKey=nF3K9Vry9z3nNDwSYxxRKw==`;
      return apiConfig.get(uri, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        commit('setDateAappointments', response);
      });
    },
    async getAppointmentRequest({ commit }, { territoriesFormat }) {
      const appointments: any[] = [];

      // eslint-disable-next-line no-restricted-syntax
      for (let i = 0; i < territoriesFormat?.length; i += 1) {
        const params = {
          territoryId: territoriesFormat[i].id,
          agentId: territoriesFormat[i].agentId,
          tokenKey: territoriesFormat[i].tokenKey,
        };
        // eslint-disable-next-line no-await-in-loop
        const appointment = await getAppointment(params);
        appointments.push(...appointment);
      }
      commit('setAppointmentsNotificationAppoint', appointments);
    },
    async getAppointmentRequestData({ state, commit }, { document, tokenKey }) {
      const agent = await getAgent({ tokenKey, document });
      getAppointmentByCdAgent(agent.id).then((data) => {
        if (!data.hasErrors) {
          commit('setAppointmentsNotification', data);
        }
      });
      state.cdAgent = agent.id;
    },
    async getQuestionByEvidenceId({ commit }, params: GetQuestionParams) {
      const data = await getQuestionByEvidenceId(params);
      commit('setQuestion', data.objectResult[0]);
    },
  },
  getters: {
    DataPix: (state) => state.DataPix,
    userLogged: (state) => state.userLogged,
    notificationData: (state) => state.notificationData,
    DateById: (state) => state.DateById,
    DataNotification: (state) => state.DataNotification,
    Link: (state) => state.Link,
    appointments: (state) => state.appointments,
    DateAct: (state) => state.DateAct,
    DateFrigo: (state) => state.DateFrigo,
    ticket: (state) => state.ticket,
    act: (state) => state.act,
    genericReadData: (state) => state.genericReadData,
    getNotificationsUnread(state) {
      return state.notificationsUnread.map((notification): NotificationEntity => {
        const { text, type, tag } = switchNotificationType(
          notification.type,
          notification.status,
          {
            issuerName: notification.issuerName,
            territoryName: notification.territoryName,
            receiverName: notification.receiverName,
            date: notification.dtSolicitation,
          },
          state.isFrig,
        );

        return {
          id: notification.id,
          viewed: notification.read,
          time: moment(notification.dtSolicitation).calendar(),
          text,
          type: (type as any) ?? undefined,
          tag,
          url: notification.url,
        };
      });
    },
    getNotificationsRead(state) {
      return state.notificationsRead.map((notification): NotificationEntity => {
        const { text, type, tag } = switchNotificationType(
          notification.type,
          notification.status,
          {
            issuerName: notification.issuerName,
            territoryName: notification.territoryName,
            receiverName: notification.receiverName,
            date: moment(notification.dtResponse).calendar(),
          },
          state.isFrig,
        );

        return {
          id: notification.id,
          viewed: notification.read,
          time: moment(notification.dtResponse).calendar(),
          text,
          type: (type as any) ?? undefined,
          tag,
          url: notification.url,
        };
      });
    },
    getAppointmentNotification(state) {
      const { appointmentsNotification } = state;

      const notificationOrder = lodash.orderBy(appointmentsNotification, (item) => new Date(item.dtAppointment));

      return notificationOrder.map((appointment: any): NotificationEntity => {
        const { dtAppointment, type, stCar } = appointment;
        const text = formatAppointmentText(dtAppointment, type.type, stCar);

        return {
          id: appointment.id,
          viewed: appointment.isRead,
          time: moment(appointment.dtAppointment).calendar(),
          text,
          type: 'info',
          tag: '',
        };
      });
    },
    getAppointmentForCalendar(state) {
      const { appointments } = state;
      const sorted = appointments.sort((a, b) => moment(a.dtAppointment).valueOf() - moment(b.dtAppointment).valueOf());

      return sorted.map((appointment, index) => {
        const color = appointment.type.color === 'green' ? 'orange' : appointment.type.color;
        return {
          key: index,
          dates: new Date(appointment.dtAppointment),
          customData: {
            title: appointment.type.type,
            class: color,
          },
          id: appointment.cdTerritory,
          color,
          car: appointment?.car || appointment?.stCar,
        };
      });
    },
    getQuestions(state) {
      const { quiz, quizAnswers } = state.question;
      const quizQuestions = quiz?.quizQuestions;

      return quizQuestions?.map((quizQuestion) => {
        const { quizOptions } = quizQuestion;
        const options = [] as any[];

        // eslint-disable-next-line default-case
        switch (quizQuestion.fkQuizQuestionType) {
          case QuestionType.singleSelection:
          case QuestionType.multipleChoice:
          case QuestionType.onlyChoice:
            options.push(...objectiveQUestion(quizOptions, quizAnswers));
            break;
          case QuestionType.text:
            options.push(subjectivQuestion(quizQuestion, quizAnswers));
            break;
        }

        return {
          id: quizQuestion.cdQuizQuestion,
          title: quizQuestion.vlQuestion,
          questionType: quizQuestion.fkQuizQuestionType,
          options,
        };
      });
    },
    getRouter: (state) => state.routes.filter((router) => router.name),
    hasAvaliableVoucher: (state) => state.hasAvaliableVoucher,
    hasTermsAccept: (state) => state.termsAccept,
  },
});
